import { Routes, Route, usePanelHistoryTop } from 'weblite-router'
import { SignIn } from '$comp/signin'
import { SignUp } from '$comp/signup'
import { Verification } from '$comp/verification'
import { VisibilityHandler } from './components/visibility-handler'
import { PrivacyPolicy } from '$comp/_app/components/leftPanel/components/privacy-policy/privacy-policy'
import { AuthContainer } from '$comp/auth-container'

const PAGES = {
  signIn: SignIn,
  verify: Verification,
  signUp: SignUp,
  privacyPolicy: PrivacyPolicy,
}

export function Auth() {
  const { state } = usePanelHistoryTop('root') || {}

  return (
    <VisibilityHandler zIndex={1}>
      <AuthContainer>
        <Routes>
          {Object.keys(PAGES).map((page: keyof typeof PAGES) => {
            const Component = PAGES[page]

            return (
              <Route
                key={page}
                name={page}
                element={<Component {...state} />}
              />
            )
          })}
        </Routes>
      </AuthContainer>
    </VisibilityHandler>
  )
}
